
/* eslint-disable */
import React, { useEffect } from 'react'

// Import page components to build yap content components 
import { Section, Stack, Spacer, Seperator, Box, Text, Image, DateText, ActionButton, Gallery, Info, View, useViewState, InspectorControlSelect, InspectorListItems } from '@yapstudios/yap-content-builder'
import { InspectorHeader , InspectorContent, InspectorProperty, InspectorControlText, InspectorControlButton, InspectorControlDate, useInspectorState }  from '@yapstudios/yap-content-builder'
import { YapUI, Component } from '@yapstudios/yap-content-builder'

export default class AthenaImageQuestionComponent {
    constructor(title) {
        this.type = 'athena-image-question'
        this.defaultTitle = title ?? 'Quiz Question Title'
        this.answers = ['Option 1', 'Option 2', 'Option 3']
    }

    defaultProps() {
        return {
            title: this.defaultTitle,
            answers : ['Option 1', 'Option 2', 'Option 3'],
            correctAnswer : 0
        }
    }

    decode(props) {    

        const id = "image-question"
        const model = {...props, id: id}

        const answerTitle = (
            <Text readonly={true} color={"accent"} content={model.answers[model.correctAnswer]}>
            </Text>
        )

        let size = {
            width: 440, height: 300
        }

        return (
            <Section id="athena-image-question" title="Image Question">
                <Stack spacing={10} align={"center"} >
                    <Image id="image" cornerRadius={8} placeholder={true} dimensions={props.dimensions} src={props.src} crop={props.crop} description={props.description} height={size.height} width={size.width} contentMode={"fill"} accessibilityLabel="Icon"></Image>
                    
                    <View id={id} model={model} width={size.width} inspector={this.inspector}>
                        <Stack width={size.width}>{answerTitle}</Stack>
                    </View>
                    
                </Stack>
            </Section>
        )
    }

    inspector(model, updateModel) {

        let answers = model.answers ?? []

        const onDelete = (index) => {
            model.answers.splice(index, 1);
            updateModel(model)
        }

        const onMove = (oldIndex, newIndex) => {
            const moveItem = model.answers[oldIndex];
            model.answers[oldIndex] = model.answers[newIndex];
            model.answers[newIndex] = moveItem;
            setTimeout(() => updateModel(model), 0);            
        }

        // Add or replace an image
        const addAnswer = () => {
            let answer = "New Answer"
            model.answers.push(answer)
            updateModel(model)
        }

        const answerItems = answers.map( (answer, idx) => {
            var key = idx
            return (
                    <InspectorControlText key={key} value={answer} onChange={v => {
                        model.answers[idx] = v
                        updateModel(model)
                    }} />
                )
        })

        const correctOptionKeys = answers.map( (obj, idx) => {
            return idx
        })
    
        return (
            <InspectorContent key={"quiz-inspector"}>
                    <InspectorHeader title={"Quiz Question"} />
                    <Stack spacing={20} align={"leading"} width={"infinity"}>
                        <InspectorProperty key={"answers"}  width={"infinity"} property={'answers'} singleColumn={true} title={"Answers"}>     
                            <Stack spacing={10}>
                                <InspectorListItems key={"listItems"} onDelete={onDelete} onMove={onMove}>
                                    {answerItems}
                                </InspectorListItems>
                                <InspectorControlButton title="Add Answer" onClick={addAnswer}/>
                            </Stack>
                        </InspectorProperty>
                        
                        <InspectorProperty  width={"infinity"} property={'correctAnswer'} singleColumn={false} title={'Correct Answer'}>
                            <InspectorControlSelect value={model.correctAnswer} options={answers} keys={correctOptionKeys} onChange={(v) => {
                                model.correctAnswer = v
                                updateModel(model)
                            }} />
                        </InspectorProperty>
                    </Stack>
                </InspectorContent>
        )
    }

    encode(model, props) {
        switch (model.id) {
            case 'image':
                props.src = model.src
                props.crop = model.crop
                props.dimensions = model.dimensions
                break;
            case 'title':
                props.title = model.title
                break;
            case 'image-question':
                props.title = model.title
                props.correctAnswer = model.correctAnswer
                break;  
            default:
                break
        }

        return props
    }

    yapUI(props) {
        return YapUI.Directive('AthenaQuizContentResponse', { 
                                        title: YapUI.Val(props.title), 
                                        correctAnswer: YapUI.Val(props.correctAnswer),
                                        answers: YapUI.Val(props.answers),
                                        //answerContent: quizOptions
                                    }, [
                                        YapUI.Directive('AnthenaArcCanvasImage', { url: YapUI.Val(props.src) })
                                    ])
    }

    yapUIReact(props) {
        return (
            <Component name="AthenaQuizContentResponse" title={props.title} correctAnswer={props.correctAnswer} answers={props.answers}>
                <Component name="AnthenaArcCanvasImage" url={props.src} />
            </Component>
        )        
    }

    icon() {
        return (
            <svg width="100" height="71" viewBox="0 0 100 71" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_39_92)">
            <path d="M100 0.591248H0V70.5912H100V0.591248Z" fill="white"/>
            <path d="M93 2.59125H7C4.23858 2.59125 2 4.82982 2 7.59125V63.5912C2 66.3527 4.23858 68.5912 7 68.5912H93C95.7614 68.5912 98 66.3527 98 63.5912V7.59125C98 4.82982 95.7614 2.59125 93 2.59125Z" stroke="white" stroke-width="4"/>
            <rect x="6" y="6" width="87" height="59" rx="7" fill="#C3C9EC"/>
            <path d="M55.8691 38.9512C55.9395 39.5293 55.8086 39.9707 55.4766 40.2754C55.1484 40.584 54.6387 40.7383 53.9473 40.7383H45.0176C44.4473 40.7383 44.0098 40.5898 43.7051 40.293C43.4004 40 43.2441 39.5742 43.2363 39.0156L45.4102 37.0938C45.5312 36.9844 45.6504 36.9043 45.7676 36.8535C45.8887 36.7988 46.0195 36.7715 46.1602 36.7715C46.2969 36.7715 46.4316 36.8008 46.5645 36.8594C46.7012 36.9141 46.8301 36.9941 46.9512 37.0996L48.0293 38.0723L50.6719 35.7109C50.8047 35.5938 50.9434 35.5078 51.0879 35.4531C51.2324 35.3945 51.3848 35.3652 51.5449 35.3652C51.6973 35.3652 51.8477 35.3945 51.9961 35.4531C52.1484 35.5117 52.2891 35.5996 52.418 35.7168L55.8691 38.9512ZM47.3555 35.9688C47.0898 35.9688 46.8457 35.9043 46.623 35.7754C46.4043 35.6465 46.2285 35.4727 46.0957 35.2539C45.9668 35.0312 45.9023 34.7871 45.9023 34.5215C45.9023 34.2598 45.9668 34.0195 46.0957 33.8008C46.2285 33.5781 46.4043 33.4023 46.623 33.2734C46.8457 33.1406 47.0898 33.0742 47.3555 33.0742C47.6172 33.0742 47.8574 33.1406 48.0762 33.2734C48.2949 33.4023 48.4688 33.5781 48.5977 33.8008C48.7305 34.0195 48.7969 34.2598 48.7969 34.5215C48.7969 34.7871 48.7305 35.0312 48.5977 35.2539C48.4688 35.4727 48.2949 35.6465 48.0762 35.7754C47.8574 35.9043 47.6172 35.9688 47.3555 35.9688ZM44.5723 41.377C43.9043 41.377 43.3926 41.1992 43.0371 40.8438C42.6816 40.4922 42.5039 39.9844 42.5039 39.3203V32.2305C42.5039 31.5625 42.6816 31.0527 43.0371 30.7012C43.3926 30.3496 43.9043 30.1738 44.5723 30.1738H54.4219C55.0938 30.1738 55.6055 30.3516 55.957 30.707C56.3125 31.0586 56.4902 31.5664 56.4902 32.2305V39.3203C56.4902 39.9844 56.3125 40.4922 55.957 40.8438C55.6055 41.1992 55.0938 41.377 54.4219 41.377H44.5723ZM44.7363 39.8652H54.2578C54.4922 39.8652 54.6699 39.8066 54.791 39.6895C54.916 39.5684 54.9785 39.3828 54.9785 39.1328V32.4121C54.9785 32.1621 54.916 31.9785 54.791 31.8613C54.6699 31.7441 54.4922 31.6855 54.2578 31.6855H44.7363C44.502 31.6855 44.3223 31.7441 44.1973 31.8613C44.0762 31.9785 44.0156 32.1621 44.0156 32.4121V39.1328C44.0156 39.3828 44.0762 39.5684 44.1973 39.6895C44.3223 39.8066 44.502 39.8652 44.7363 39.8652Z" fill="white"/>
            </g>
            <defs>
            <clipPath id="clip0_39_92">
            <rect width="100" height="71" fill="white"/>
            </clipPath>
            </defs>
            </svg>
        )
    }

}
